// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NK6k","footer":"styles_footer__3kwit","passCodeTooltip":"styles_passCodeTooltip__3TVgF"};